import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, useTheme } from '@mui/material';
import { MarketButton, MarketLink } from '@market/react';
import { shopImageSrcSet } from 'utilities/images';

const InStockOptions = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { content } = props;

  return (
    <>
      {content.map(
        (
          {
            product_name: productName,
            subtitle: description,
            thumbnail_url: thumbnailUrl,
            overview_url: learnUrl,
            buy_url: buyUrl,
          },
          idx,
        ) => (
          <Grid
            key={productName}
            container
            spacing={1}
            alignItems="center"
            sx={{ mb: idx === content.length - 1 ? 5 : 2 }}
          >
            <Grid item xs={4}>
              <img
                alt={productName}
                srcSet={shopImageSrcSet({
                  baseUrl: thumbnailUrl,
                  type: 'productTile',
                })}
                width="100%"
                style={{ objectFit: 'contain' }}
              />
            </Grid>
            <Grid item xs={8}>
              <p className="medium-30">{productName}</p>
              <p style={{ margin: theme.spacing(1, 0) }}>{description}</p>
              <Grid
                item
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item>
                  {learnUrl && (
                    <MarketLink href={learnUrl}>
                      {t('productPage.learnMore')}
                    </MarketLink>
                  )}
                </Grid>
                <MarketButton
                  id="product-buy-btn"
                  rank="primary"
                  size="small"
                  href={buyUrl}
                >
                  {t('productPage.buy')}
                </MarketButton>
              </Grid>
            </Grid>
          </Grid>
        ),
      )}
    </>
  );
};

export default InStockOptions;
